import React from "react";
import AnimatedHeading from "../../atoms/typography/AnimatedHeading";
import ScrollIndicator from "./ScrollIndicator";
import Navbar from "../Navbar/Navbar";

/**
 * Full-screen hero section with animated text and background
 * @param {Object} props
 * @param {string} props.backgroundImage - Background image URL
 * @param {string} props.title - Main heading text
 * @param {string} props.subtitle - Subtitle text
 */
const HeroSection = ({ backgroundImage, title, subtitle }) => {
  return (
    <section
      className="relative w-full h-screen min-h-[600px] flex flex-col"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/30" />

      {/* Top gradient for nav visibility */}
      <div className="absolute top-0 inset-x-0 h-48 bg-gradient-to-b from-black/70 to-transparent" />

      {/* Content */}
      <div className="relative z-10 flex flex-col h-full">
        {/* Navbar */}
        <div className="pt-4 px-4">
          <Navbar />
        </div>

        {/* Hero content */}
        <div className="flex-1 flex flex-col items-center justify-center px-4 text-center">
          <AnimatedHeading
            text={title}
            className="display-hero text-white [text-shadow:0_4px_20px_rgba(0,0,0,0.4)]"
            delayStart={300}
            letterDelay={60}
          />

          <p
            className="mt-6 text-lg sm:text-xl md:text-2xl text-white/90 font-light max-w-2xl opacity-0 animate-fade-up animation-delay-800"
            style={{ animationFillMode: "forwards" }}
          >
            {subtitle}
          </p>
        </div>

        {/* Scroll indicator */}
        <div className="pb-8">
          <ScrollIndicator className="opacity-0 animate-fade-up animation-delay-1000" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
